module.exports = __webpack_public_path__ + "media/images/emoticons/appli01-f11681c3a000c24727abc9e264b1b3cc.gif";